/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { merge } from '@bingads-webui-universal/primitive-utilities';
import {
  schemas,
} from '@bingads-webui/campaign-odata-schemas';
import * as bulkUpsertSchema from '@bingads-webui/odata-bulk-upsert-config';

window.performance.SchemaNewLatency = {
  Name: 'Schema-New.Additional.Latency',
  StartTime: window.performance.now(),
};

const regexModel = /^Model\//;

function getKey(val) {
  if (val.key) {
    return val.key;
  }

  if (val.$$ODataExtension.Key) {
    return val.$$ODataExtension.Key[0];
  }

  let base = val.$$ODataExtension.BaseType;

  while (base) {
    const baseVal = Array.isArray(base) ? schemas[base.$ref[0]] : schemas[base.$ref];

    if (baseVal.$$ODataExtension && baseVal.$$ODataExtension.Key) {
      return baseVal.$$ODataExtension.Key[0];
    }

    base = baseVal.$$ODataExtension.BaseType;
  }

  return undefined;
}

function copyPropsOnPrototype(target) {
  if (!_.isObject(target)) {
    return;
  }

  const proto = Object.getPrototypeOf(target);

  if (proto.$$ODataExtension) {
    // if this is a referenced object schema, then we only move the type out of prototype
    // because other things are read from dist.schema
    if (target.schema) {
      target.type = Object.prototype.hasOwnProperty.call(target, 'type') ? target.type : proto.type;
    } else {
      _.each(proto, (val, key) => {
        if (key !== '$$ODataExtension' && !Object.prototype.hasOwnProperty.call(target, key)) {
          target[key] = val;
        }
      });
    }
  }

  _.each(target, (val, key) => {
    if (key !== 'schema') {
      copyPropsOnPrototype(val);
    }
  });
}

function deepSetValue(src, pathArr, value) {
  let target = src;
  _.forEach(pathArr, (path, index) => {
    if (index < pathArr.length - 1) {
      target[path] = { ...target[path] };
      target = target[path];
      return;
    }

    target[path] = value;
  });
}

window.performance.SchemaNewLatency.ForEach1Start = window.performance.now();

// legacy code use this 'datetime' type to find date, in new schema this field is string type.
schemas['Edm/DateTimeOffset'].type = 'datetime';

_.each(schemas, (val, key) => {
  val.name = val.$$ODataExtension.Name;

  if (regexModel.test(key)) {
    // changes below are for backward compatibility
    // we can change legacy code logic to remove these changes
    val.key = getKey(val);
    if (val.key) {
      val.properties[val.key].key = true;
    }

    // feature may deepClone, which will loss property in prototype, so move them out first
    copyPropsOnPrototype(val);

    // basetype is object, will trigger error in ui next adextension bult edit page
    // delete it for now, maybe we can choose not de-ref the #ref in basetype
    delete val.$$ODataExtension.BaseType;
  }
});

window.performance.SchemaNewLatency.ForEach1End = window.performance.now();

const result = {};

window.performance.SchemaNewLatency.ForEach2Start = window.performance.now();

_.each(schemas, (val, key) => {
  if (regexModel.test(key)) {
    // remove the start Model/ namespace
    const keyWithoutNamespace = key.replace(regexModel, '');

    result[keyWithoutNamespace] = val;
  }
});

_.each(bulkUpsertSchema, (bSchema, name) => {
  merge(result[name], bSchema);
});

window.performance.SchemaNewLatency.ForEach2End = window.performance.now();

window.performance.SchemaNewLatency.ProductGroupStart = window.performance.now();
// TODO: we don't support nested override in new schema for now, so define it here.
// remove this when new schema support that.
deepSetValue(result.ProductGroup, [
  'properties',
  'BidAmount',
  'schema',
  'properties',
  'Bid',
  'schema',
  'properties',
  'Amount',
  'filterable',
], true);
deepSetValue(result.ProductGroup, [
  'properties',
  'BidBoost',
  'schema',
  'properties',
  'Multiplier',
  'filterable',
], true);
deepSetValue(result.ProductGroup, [
  'properties',
  'Condition',
  'schema',
  'properties',
  'Attribute',
  'filterable',
], true);
deepSetValue(result.HotelListingGroup, [
  'properties',
  'BidAmount',
  'schema',
  'properties',
  'Bid',
  'schema',
  'properties',
  'Amount',
  'filterable',
], true);
// HotelListingGroup does not have `BidBoost` as property now.
// But we comment such lines for future.
// deepSetValue(result.HotelListingGroup, [
//   'properties',
//   'BidBoost',
//   'schema',
//   'properties',
//   'Multiplier',
//   'filterable',
// ], true);
deepSetValue(result.HotelListingGroup, [
  'properties',
  'Condition',
  'schema',
  'properties',
  'Attribute',
  'filterable',
], true);
window.performance.SchemaNewLatency.ProductGroupEnd = window.performance.now();

result.$ROOT = {
  name: '$ROOT',
  type: 'object',
  properties: {
    Customers: {
      type: 'array',
      items: {
        schema: result.Customer,
        __proto__: result.Customer,
      },
    },
  },
};

result.DynamicSearchAd.properties.Text.maxLength = 80;
result.ExpandedTextAd.properties.Text.maxLength = 80;
result.ExpandedTextAd.properties.Text.traditionalChineseMaxLength = 40;

function appendDynamicInfoToSchema(cfg, obj) {
  // TODO: yaoyao move below logic to a separate package, we may need these in new ui schema as well
  const permissions = cfg.get('Permissions') || {};

  const numberOfDigits = cfg.get('globalization.number.numberOfDigits');

  if (numberOfDigits === 0) {
    obj.Budget.properties.Amount.type = 'integer';
    obj.Budget.properties.Amount.name = 'Int64';
  }

  obj.AdGroup.properties.Name.maxLength = _.result(permissions, 'IsAdGroupNameCharLimitIncreaseEnabled', false) ? 256 : 128;
  obj.AdGroup.properties.SearchBid.maximum = _.result(cfg.get('KeywordBidRange'), 'CeilingValue');
  obj.AdGroup.properties.SearchBid.minimum = _.result(cfg.get('KeywordBidRange'), 'FloorValue');
  obj.AdGroup.properties.ContentBid.maximum = _.result(cfg.get('KeywordBidRange'), 'CeilingValue');
  obj.AdGroup.properties.ContentBid.minimum = _.result(cfg.get('KeywordBidRange'), 'FloorValue');
  obj.AdGroup.properties.CpmBid.maximum = _.result(cfg.get('KeywordBidRange'), 'CeilingValue');
  obj.AdGroup.properties.CpmBid.minimum = _.result(cfg.get('KeywordBidRange'), 'FloorValue');
  obj.AdGroup.properties.CpvBid.maximum = _.result(cfg.get('KeywordBidRange'), 'CeilingValue');
  obj.AdGroup.properties.CpvBid.minimum = _.result(cfg.get('KeywordBidRange'), 'FloorValue');
  obj.CallAdExtension.properties.CountryCode.default = cfg.get('market') || 'US';

  obj.CoOpSetting.properties.BidMaxValue.maximum = _.result(cfg.get('KeywordBidRange'), 'CeilingValue');
  obj.CoOpSetting.properties.BidMaxValue.minimum = _.result(cfg.get('KeywordBidRange'), 'FloorValue');

  obj.DynamicSearchAd.properties.Text.maxLength = 90;

  obj.ExpandedTextAd.properties.Text.maxLength = 90;
  obj.ExpandedTextAd.properties.Text.traditionalChineseMaxLength = 45;

  const ProductGroupBidRange = cfg.get('ProductGroupBidRange');

  obj.ProductGroup.properties.BidAmount.schema.properties.Bid.schema.properties.Amount.maximum = _.result(ProductGroupBidRange, 'CeilingValue', 1000);
  obj.ProductGroup.properties.BidAmount.schema.properties.Bid.schema.properties.Amount.minimum = _.result(ProductGroupBidRange, 'FloorValue', 0.01);

  obj.ProductPartition.properties.BidAmount.maximum = _.result(ProductGroupBidRange, 'CeilingValue', 1000);
  obj.ProductPartition.properties.BidAmount.minimum = _.result(ProductGroupBidRange, 'FloorValue', 0.01);

  obj.DimensionLanding.properties.FinalUrlSuffix.filterable = true;
}

window.performance.SchemaNewLatency.EndTime = window.performance.now();

export { appendDynamicInfoToSchema, result };
